// ModuleJobStatus：轮询 /api/module-jobs/{id} 显示模块批量命令进度。

import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/api/client";
import { moduleJobPath } from "@/api/endpoints";
import type { ModuleJobState } from "@/api/types";
import { QueryView } from "@/components/ui/QueryView";
import { StatusBadge } from "@/components/ui/StatusBadge";

export interface ModuleJobStatusProps {
  jobID: string;
}

export function ModuleJobStatus({ jobID }: ModuleJobStatusProps) {
  const q = useQuery({
    queryKey: ["module-job", jobID],
    queryFn: () => apiGet<ModuleJobState>(moduleJobPath(jobID)),
    refetchInterval: (query) =>
      query.state.data?.status === "completed" ? false : 5_000,
  });

  return (
    <QueryView query={q}>
      {(job) => (
        <div className="space-y-2 rounded border border-[hsl(var(--border))] p-3 text-xs">
          <div className="flex items-center gap-2">
            <span className="font-mono">{job.id}</span>
            <StatusBadge variant={job.status === "completed" ? "ok" : "warn"}>
              {job.status}
            </StatusBadge>
            <span className="text-[hsl(var(--muted-foreground))]">
              {job.completed}/{job.total} (ok {job.ok}, fail {job.failed})
            </span>
          </div>
          {job.last_error ? (
            <div className="text-[hsl(var(--danger))]">{job.last_error}</div>
          ) : null}
          {job.results.length > 0 ? (
            <details className="text-[10px]">
              <summary className="cursor-pointer">详细结果</summary>
              <ul className="mt-1 space-y-0.5">
                {job.results.map((r, i) => (
                  <li key={i} className="font-mono">
                    {r.ok ? "✓" : "✕"} acc={r.account_id} {r.module}
                    {r.error ? ` — ${r.error}` : ""}
                  </li>
                ))}
              </ul>
            </details>
          ) : null}
        </div>
      )}
    </QueryView>
  );
}
